import { AnyAction, Reducer } from "redux";

import type { IUserReducer } from "./types";
import {
    SET_USER_REGISTARTION_STEPS,
    SET_CURRENT_USER,
    SET_USER_INFO,
    CLEAR_CURRENT_USER_DATA,
    SET_USER_CURATOR_DATA,
    SET_USER_CURATOR_DATA_LOADED,
    SET_USER_CURRENCY,
    SET_USER_SETTINGS,
    UPDATE_USER_SETTINGS,
    defaultSettings
} from "./constants";

const intitialState = {
    currentUser: {
        data: {
            id: "",
            email: "",
            name: "",
            roles: [],
            realm_access_roles: [],
            accessToken: null,
            avatar: null,
        },
        userLoaded: false,
        getUserLoadError: null,
        info: {
            plan: null,
            balance: null,
            id: null,
            supportID: null,
            chatSessionId: null
        },
        settings: null,
        currency: 'RUB',
        registrationSteps: {
            data: null,
        },
        curator: {
            data: null,
            isLoaded: false
        }
    },
    savedAccounts: [],
}


const users: Reducer<IUserReducer, AnyAction> = (state = intitialState, action): IUserReducer => {
    switch (action.type) {

        case SET_CURRENT_USER: {
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    data: action.payload.userData,
                    userLoaded: true,
                    getUserLoadError: null
                },
                savedAccounts: action.payload.savedAccounts
            }
        }

        case CLEAR_CURRENT_USER_DATA: {
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    data: {
                        id: "",
                        email: "",
                        name: "",
                        realm_access_roles: [],
                        roles: [],
                        avatar: "",
                        accessToken: null
                    },
                    userLoaded: false,
                    getUserLoadError: null,
                    info: {
                        plan: null,
                        balance: null,
                        id: null,
                        supportID: null,
                        chatSessionId: null,
                    },
                    settings: defaultSettings,
                    registrationSteps: {
                        data: null
                    }
                },
            }
        }

        case "SET_USER_SAVED_ACCOUNTS": {
            return {
                ...state,
                savedAccounts: action.payload
            }
        }

        case SET_USER_REGISTARTION_STEPS: {

            const arrayOfSteps = action.payload;
            let isRegistered = false,
                isAgreementAccepted = false;


            if (arrayOfSteps && arrayOfSteps.length) {
                arrayOfSteps.includes("COMPLETE_REGISTRATION") ? isRegistered = true : isRegistered = false;
                arrayOfSteps.includes("ACCEPT_SERVICE_AGREEMENT") ? isAgreementAccepted = true : isAgreementAccepted = false;
            }

            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    registrationSteps: {
                        data: {
                            completeRegistration: isRegistered,
                            acceptServiceAgreement: isAgreementAccepted
                        }
                    }
                }
            }
        }

        case SET_USER_SETTINGS: {
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    settings: {
                        ...defaultSettings,
                        ...action.payload
                    }
                }
            }
        }

        case UPDATE_USER_SETTINGS: {
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    settings: action.payload
                }
            }
        }

        case SET_USER_INFO: {
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    info: action.payload
                }
            }
        }

        case SET_USER_CURRENCY: {
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    currency: action.payload
                }
            }
        }

        case SET_USER_CURATOR_DATA: {
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    curator: {
                        data: action.payload,
                        isLoaded: true
                    }
                }
            }
        }

        case SET_USER_CURATOR_DATA_LOADED: {
            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    curator: {
                        ...state.currentUser.curator,
                        isLoaded: action.payload
                    }
                }
            }
        }

        default: return state;
    }
}

export default users;